import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  loading: boolean;
  userEmail: string | null;

  handleClose: () => void;

  handleSyncLinkedinAccount: () => void;
}

const AskForSyncDialog: React.FC<Props> = ({ open, loading, userEmail, handleClose, handleSyncLinkedinAccount }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('askForSyncDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            <Trans i18nKey={'askForSyncDialogContent1'} values={{ userEmail: userEmail || '' }}>
              Your LinkedIn account <strong>email</strong> is possibly not logged in.
            </Trans>
          </Typography>
          <Typography className={classes.text}>{t('askForSyncDialogContent2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('loginNow')} size={'lg'} underline={'always'} action={handleSyncLinkedinAccount} disabled={loading} />
        <PaiButton text={t('stayLoggedOut')} size={'small'} border={'rounded'} action={handleClose} disabled={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
  warningText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default AskForSyncDialog;
